import React from "react";

export const PDFPreview = ({ url }) => {
  return url ? (
    <object className="flex-1" data={url} key={url}>
      Can&apos;t be rendered
    </object>
  ) : null;
};
